import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import './AmexGDAOffersApplyNow.scss';
import { ACQUISITION_CTA_EVENT_NAME } from '../../../AmexMarketingUtils/constants';
import { handleMktAnalytics } from '../../../AmexMarketingUtils/AmexUtils';

const AmexGDAOffersApplyNow = (props) => {
  const {
    amexCardData: {
      applyNowLink,
    },
    resyCardData: {
      productApplyLinkLabel,
      applyNowAriaLabel,
    },
    campaignId,
    utmValues,
    referrer,
    Analytics,
  } = props;

  const handleApplyNowClick = () => {
    handleMktAnalytics(Analytics.event, ACQUISITION_CTA_EVENT_NAME, { action_name: 'NAA - Platinum Apply now CTA Click' });
  };

  const renderApplyNow = () => {
    const buildCampaignString = () => (campaignId ? `&extlink=${campaignId}` : '');

    const buildReferringDomain = () => {
      const utmCampaignValue = `${utmValues}${buildCampaignString(campaignId)}`;
      let referringDomain = '';
      if (referrer) {
        if (utmCampaignValue) {
          referringDomain = `&referring_domain=${referrer}`;
        } else {
          referringDomain = `?referring_domain=${referrer}`;
        }
      }
      return referringDomain;
    };

    const hrefLink = `${applyNowLink}${utmValues}${buildCampaignString()}${buildReferringDomain()}`;
    return (
      <Link
        href={hrefLink}
        className="AmexGDAOffersApplyNow__link"
        onContextMenu={() => handleApplyNowClick()}
        onClick={() => handleApplyNowClick()}
        target="_blank"
        aria-label={applyNowAriaLabel}
      >
        {productApplyLinkLabel}
      </Link>
    );
  };

  return renderApplyNow();
};
AmexGDAOffersApplyNow.propTypes = {
  cardName: PropTypes.string.isRequired,
  campaignId: PropTypes.string.isRequired,
  utmValues: PropTypes.string.isRequired,
  referrer: PropTypes.string.isRequired,
  Analytics: PropTypes.shape({
    event: PropTypes.func,
  }).isRequired,
  amexCardData: PropTypes.shape({
    applyNowLink: PropTypes.string,
  }).isRequired,
  resyCardData: PropTypes.shape({
    gdaApplyNowTrack: PropTypes.string,
    productApplyLinkLabel: PropTypes.string,
  }).isRequired,
};
export default AmexGDAOffersApplyNow;
